<template>
  <b-modal
      v-model="show"
      title="Modifier le titre de la conversation"
      hide-header-close
      centered
      @shown="selectAllContent"
      @ok="handleSave"
      @cancel="handleCancel"
  >
    <b-form-input
        ref="conversationTitle"
        v-model="newTitle"
        placeholder="Titre de la Conversation"
        autofocus
        @keyup.enter="handleSave"
    />

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="handleCancel">
        Annuler
      </b-button>
      <b-button variant="primary" :disabled="!newTitle.trim()" @click="handleSave">
        Modifier
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {BButton, BFormInput, BModal} from "bootstrap-vue";

export default {
  name: 'ChatEditModal',
  components: {BButton, BFormInput, BModal},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: this.visible,
      newTitle: this.currentTitle
    }
  },
  watch: {
    visible(val) {
      this.show = val
    },
    currentTitle(val) {
      this.newTitle = val
    }
  },
  methods: {
    selectAllContent() {
      this.$refs.conversationTitle.$el.select()
    },
    handleSave() {
      if (!this.newTitle.trim()) return
      this.$emit('save', this.newTitle.trim())
      this.show = false
    },
    handleCancel() {
      this.newTitle = this.currentTitle
      this.$emit('cancel')
      this.show = false
    }
  }
}
</script>